import React, { Component } from 'react';
import { withRouter } from '../../../services/withRoute';
import jwt_decode from 'jwt-decode';
import _ from 'lodash';

class AdminLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			specialCase: ['640ebab69ec47cd24aaeab89', '63fb8b151cced2d24dc9553e'],
		};
	}

	componentDidMount = async () => {
		let usertoken = localStorage.getItem('usertoken');
		let decoded = await jwt_decode(usertoken);
		this.setState({
			userName: decoded.userName,
			userId: decoded.user_id,
		});
	};

	render() {
		return (
			<div className="admin-layout">
				<div className="al-sidebar">
					<a
						className={
							this.props.locations.pathname.split('/')[3] === 'register-equipments'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(
								`/${this.props.params.vendorID}/admin-tools/register-equipments`,
							)
						}
					>
						{' '}
						Register Eq
					</a>

					<a
						className={
							this.props.locations.pathname.split('/')[3] === 'register-memory-card'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(
								`/${this.props.params.vendorID}/admin-tools/register-memory-card`,
							)
						}
					>
						{' '}
						Register MC
					</a>

					<a
						className={
							this.props.locations.pathname.split('/')[3] === 'remap-equipment'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(
								`/${this.props.params.vendorID}/admin-tools/remap-equipment`,
							)
						}
					>
						Remap Eq
					</a>

					<a
						className={
							this.props.locations.pathname.split('/')[3] === 'remap-memorycard'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(
								`/${this.props.params.vendorID}/admin-tools/remap-memorycard`,
							)
						}
					>
						Remap MC
					</a>

					<a
						className={
							this.props.locations.pathname.split('/')[3] === 'register-assets'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(
								`/${this.props.params.vendorID}/admin-tools/register-assets`,
							)
						}
					>
						Register Asset
					</a>

					<a
						className={
							this.props.locations.pathname.split('/')[3] === 'remap-asset'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(
								`/${this.props.params.vendorID}/admin-tools/remap-asset`,
							)
						}
					>
						Remap Asset
					</a>
					{_.indexOf(this.state.specialCase, this.state.userId) >= 0 ? null : (
						<a
							className={
								this.props.locations.pathname.split('/')[3] === 'vendor-users'
									? 'active'
									: ''
							}
							onClick={(e) =>
								this.props.navigate(
									`/${this.props.params.vendorID}/admin-tools/vendor-users`,
								)
							}
						>
							Vendor users
						</a>
					)}
				</div>
				<div className="content">{this.props.children}</div>
			</div>
		);
	}
}

export default withRouter(AdminLayout);
